module.exports = __webpack_public_path__ + "img/獅子座.91d232ef.svg";